import { TemplatePlan, TemplateItem } from 'src/types/mealplan-template';

// Sample data for mealplan templates
const SAMPLE_TEMPLATES: TemplatePlan[] = [
  {
    id: '1',
    name: 'High Protein Muscle Building',
    description: 'A high-protein meal plan designed for muscle building and recovery',
    calories: 2500,
    protein: 180,
    fat: 80,
    carbohydrates: 200,
    dietType: 'omnivore',
    intolerances: [],
    tags: ['muscle-building', 'high-protein', 'fitness'],
    mealStructure: [
      { type: 'BREAKFAST', qty: 1 },
      { type: 'SNACK', qty: 1 },
      { type: 'LUNCH', qty: 1 },
      { type: 'SNACK2', qty: 1 },
      { type: 'DINNER', qty: 1 },
      { type: 'POSTWORKOUT', qty: 1 },
    ],
    items: [
      {
        id: '1',
        templateId: '1',
        itemType: 'RECIPE',
        refId: '101',
        mealType: 'BREAKFAST',
        portion: 1,
        unit: 'serving',
        notes: 'High protein breakfast',
        sortOrder: 1,
      },
      {
        id: '2',
        templateId: '1',
        itemType: 'RECIPE',
        refId: '102',
        mealType: 'LUNCH',
        portion: 1.5,
        unit: 'serving',
        notes: 'Lean protein with complex carbs',
        sortOrder: 2,
      },
    ],
    updatedAt: '2024-01-15T10:30:00Z',
  },
  {
    id: '2',
    name: 'Vegetarian Weight Loss',
    description: 'A balanced vegetarian meal plan for healthy weight loss',
    calories: 1800,
    protein: 120,
    fat: 60,
    carbohydrates: 180,
    dietType: 'vegetarian',
    intolerances: ['lactose'],
    tags: ['vegetarian', 'weight-loss', 'balanced'],
    mealStructure: [
      { type: 'BREAKFAST', qty: 1 },
      { type: 'SNACK', qty: 1 },
      { type: 'LUNCH', qty: 1 },
      { type: 'DINNER', qty: 1 },
    ],
    items: [
      {
        id: '3',
        templateId: '2',
        itemType: 'RECIPE',
        refId: '201',
        mealType: 'BREAKFAST',
        portion: 1,
        unit: 'serving',
        notes: 'Protein-rich vegetarian breakfast',
        sortOrder: 1,
      },
    ],
    updatedAt: '2024-01-14T14:20:00Z',
  },
  {
    id: '3',
    name: 'Complete Weekly Fitness Plan',
    description: 'A comprehensive 7-day meal plan with varied meals for each day of the week',
    calories: 2200,
    protein: 160,
    fat: 70,
    carbohydrates: 220,
    dietType: 'omnivore',
    intolerances: [],
    tags: ['fitness', 'weekly', 'varied'],
    isWeekly: true,
    mealStructure: [
      { type: 'BREAKFAST', time: '07:00' },
      { type: 'LUNCH', time: '12:00' },
      { type: 'DINNER', time: '18:00' },
      { type: 'SNACK', time: '15:00' },
    ],
    items: [
      {
        id: 'weekly-1',
        templateId: '3',
        itemType: 'RECIPE',
        refId: '301',
        mealType: 'BREAKFAST',
        portion: 1,
        unit: 'serving',
        notes: 'Monday breakfast',
        sortOrder: 1,
        calories: 450,
        protein: 25,
        fat: 15,
        carbohydrates: 55,
      },
    ],
    weekItems: [
      {
        day: 0, // Monday
        mealStructure: [
          { type: 'BREAKFAST', time: '07:00' },
          { type: 'LUNCH', time: '12:00' },
          { type: 'DINNER', time: '18:00' },
        ],
        items: [
          {
            id: 'weekly-1',
            templateId: '3',
            itemType: 'RECIPE',
            refId: '301',
            mealType: 'BREAKFAST',
            portion: 1,
            unit: 'serving',
            notes: 'Monday breakfast',
            sortOrder: 1,
            calories: 450,
            protein: 25,
            fat: 15,
            carbohydrates: 55,
          },
        ],
      },
      {
        day: 1, // Tuesday
        mealStructure: [
          { type: 'BREAKFAST', time: '07:00' },
          { type: 'LUNCH', time: '12:00' },
          { type: 'DINNER', time: '18:00' },
        ],
        items: [],
      },
      {
        day: 2, // Wednesday
        mealStructure: [
          { type: 'BREAKFAST', time: '07:00' },
          { type: 'LUNCH', time: '12:00' },
          { type: 'DINNER', time: '18:00' },
        ],
        items: [],
      },
      {
        day: 3, // Thursday
        mealStructure: [
          { type: 'BREAKFAST', time: '07:00' },
          { type: 'LUNCH', time: '12:00' },
          { type: 'DINNER', time: '18:00' },
        ],
        items: [],
      },
      {
        day: 4, // Friday
        mealStructure: [
          { type: 'BREAKFAST', time: '07:00' },
          { type: 'LUNCH', time: '12:00' },
          { type: 'DINNER', time: '18:00' },
        ],
        items: [],
      },
      {
        day: 5, // Saturday
        mealStructure: [
          { type: 'BREAKFAST', time: '08:00' },
          { type: 'LUNCH', time: '13:00' },
          { type: 'DINNER', time: '19:00' },
        ],
        items: [],
      },
      {
        day: 6, // Sunday
        mealStructure: [
          { type: 'BREAKFAST', time: '08:00' },
          { type: 'LUNCH', time: '13:00' },
          { type: 'DINNER', time: '19:00' },
        ],
        items: [],
      },
    ],
    updatedAt: '2024-01-13T09:15:00Z',
  },
  {
    id: '4',
    name: 'Keto Fat Burning',
    description: 'Low-carb, high-fat meal plan for ketogenic diet',
    calories: 2000,
    protein: 140,
    fat: 150,
    carbohydrates: 50,
    dietType: 'keto',
    intolerances: [],
    tags: ['keto', 'fat-burning', 'low-carb'],
    mealStructure: [
      { type: 'BREAKFAST', qty: 1 },
      { type: 'LUNCH', qty: 1 },
      { type: 'DINNER', qty: 1 },
      { type: 'SNACK', qty: 2 },
    ],
    items: [
      {
        id: '4',
        templateId: '3',
        itemType: 'RECIPE',
        refId: '301',
        mealType: 'BREAKFAST',
        portion: 1,
        unit: 'serving',
        notes: 'High-fat keto breakfast',
        sortOrder: 1,
      },
    ],
    updatedAt: '2024-01-13T09:15:00Z',
  },
];

// Local storage keys
const STORAGE_KEYS = {
  TEMPLATES: 'ng_template_plans',
  ITEMS: 'ng_template_items',
};

// Helper functions for localStorage
const getFromStorage = (key: string) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error(`Error reading from localStorage (${key}):`, error);
    return null;
  }
};

const saveToStorage = (key: string, data: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
    return true;
  } catch (error) {
    console.error(`Error saving to localStorage (${key}):`, error);
    return false;
  }
};

// Initialize localStorage with sample data if empty
const initializeStorage = () => {
  const existingTemplates = getFromStorage(STORAGE_KEYS.TEMPLATES);
  if (!existingTemplates) {
    saveToStorage(STORAGE_KEYS.TEMPLATES, SAMPLE_TEMPLATES);
  }
  
  const existingItems = getFromStorage(STORAGE_KEYS.ITEMS);
  if (!existingItems) {
    const allItems = SAMPLE_TEMPLATES.flatMap(template => template.items);
    saveToStorage(STORAGE_KEYS.ITEMS, allItems);
  }
};

// Initialize on module load
initializeStorage();

// Mock service class
export class TemplateService {
  // Get all templates with optional filtering
  static list(filters?: any): TemplatePlan[] {
    const templates: TemplatePlan[] = getFromStorage(STORAGE_KEYS.TEMPLATES) || [];
    const items: TemplateItem[] = getFromStorage(STORAGE_KEYS.ITEMS) || [];
    
    // Merge items with templates
    const templatesWithItems = templates.map((template: TemplatePlan) => ({
      ...template,
      items: items.filter(item => item.templateId === template.id),
    }));
    
    // Apply filters if provided
    if (filters) {
      return this.applyFilters(templatesWithItems, filters);
    }
    
    return templatesWithItems.filter(template => !template.deleted);
  }

  // Get a single template by ID
  static get(id: string): TemplatePlan | null {
    const templates: TemplatePlan[] = getFromStorage(STORAGE_KEYS.TEMPLATES) || [];
    const items: TemplateItem[] = getFromStorage(STORAGE_KEYS.ITEMS) || [];
    
    const template = templates.find((t: TemplatePlan) => t.id === id && !t.deleted);
    if (!template) return null;
    
    return {
      ...template,
      items: items.filter((item: TemplateItem) => item.templateId === id),
    };
  }

  // Create a new template
  static create(data: Omit<TemplatePlan, 'id' | 'updatedAt'>): TemplatePlan {
    const templates: TemplatePlan[] = getFromStorage(STORAGE_KEYS.TEMPLATES) || [];
    const items: TemplateItem[] = getFromStorage(STORAGE_KEYS.ITEMS) || [];
    
    const newTemplate: TemplatePlan = {
      ...data,
      id: Date.now().toString(),
      updatedAt: new Date().toISOString(),
    };
    
    // Save template
    templates.push(newTemplate);
    saveToStorage(STORAGE_KEYS.TEMPLATES, templates);
    
    // Save items
    const newItems = data.items.map((item: TemplateItem) => ({
      ...item,
      id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
      templateId: newTemplate.id,
    }));
    
    items.push(...newItems);
    saveToStorage(STORAGE_KEYS.ITEMS, items);
    
    return {
      ...newTemplate,
      items: newItems,
    };
  }

  // Update an existing template
  static update(id: string, data: Partial<TemplatePlan>): TemplatePlan | null {
    const templates: TemplatePlan[] = getFromStorage(STORAGE_KEYS.TEMPLATES) || [];
    const items: TemplateItem[] = getFromStorage(STORAGE_KEYS.ITEMS) || [];
    
    const templateIndex = templates.findIndex((t: TemplatePlan) => t.id === id);
    if (templateIndex === -1) return null;
    
    // Update template
    const updatedTemplate = {
      ...templates[templateIndex],
      ...data,
      id, // Ensure ID doesn't change
      updatedAt: new Date().toISOString(),
    };
    
    templates[templateIndex] = updatedTemplate;
    saveToStorage(STORAGE_KEYS.TEMPLATES, templates);
    
    // Update items if provided
    if (data.items) {
      // Remove old items
      const filteredItems = items.filter((item: TemplateItem) => item.templateId !== id);
      
      // Add new items
      const newItems = data.items.map((item: TemplateItem) => ({
        ...item,
        id: item.id || Date.now().toString() + Math.random().toString(36).substr(2, 9),
        templateId: id,
      }));
      
      filteredItems.push(...newItems);
      saveToStorage(STORAGE_KEYS.ITEMS, filteredItems);
      
      return {
        ...updatedTemplate,
        items: newItems,
      };
    }
    
    return updatedTemplate;
  }

  // Duplicate a template
  static duplicate(id: string): TemplatePlan | null {
    const template = this.get(id);
    if (!template) return null;
    
    const duplicatedTemplate = {
      ...template,
      id: Date.now().toString(),
      name: `${template.name} (Copy)`,
      updatedAt: new Date().toISOString(),
    };
    
    // Create new items for duplicated template
    const duplicatedItems = template.items.map(item => ({
      ...item,
      id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
      templateId: duplicatedTemplate.id,
    }));
    
    duplicatedTemplate.items = duplicatedItems;
    
    return this.create(duplicatedTemplate);
  }

  // Soft delete a template
  static softDelete(id: string): boolean {
    const templates: TemplatePlan[] = getFromStorage(STORAGE_KEYS.TEMPLATES) || [];
    const templateIndex = templates.findIndex((t: TemplatePlan) => t.id === id);
    
    if (templateIndex === -1) return false;
    
    templates[templateIndex].deleted = true;
    templates[templateIndex].updatedAt = new Date().toISOString();
    
    return saveToStorage(STORAGE_KEYS.TEMPLATES, templates);
  }

  // Apply filters to templates
  private static applyFilters(templates: TemplatePlan[], filters: any): TemplatePlan[] {
    let filtered = templates.filter(template => !template.deleted);
    
    // Search text filter
    if (filters.searchText) {
      const searchLower = filters.searchText.toLowerCase();
      filtered = filtered.filter(template =>
        template.name.toLowerCase().includes(searchLower) ||
        template.description?.toLowerCase().includes(searchLower) ||
        template.tags?.some(tag => tag.toLowerCase().includes(searchLower))
      );
    }
    
    // Calorie range filter
    if (filters.calorieRange) {
      filtered = filtered.filter(template => {
        if (!template.calories) return true;
        return template.calories >= filters.calorieRange.min && 
               template.calories <= filters.calorieRange.max;
      });
    }
    
    // Macro range filters
    if (filters.macroRanges) {
      if (filters.macroRanges.protein) {
        filtered = filtered.filter(template => {
          if (!template.protein) return true;
          return template.protein >= filters.macroRanges.protein.min && 
                 template.protein <= filters.macroRanges.protein.max;
        });
      }
      
      if (filters.macroRanges.fat) {
        filtered = filtered.filter(template => {
          if (!template.fat) return true;
          return template.fat >= filters.macroRanges.fat.min && 
                 template.fat <= filters.macroRanges.fat.max;
        });
      }
      
      if (filters.macroRanges.carbohydrates) {
        filtered = filtered.filter(template => {
          if (!template.carbohydrates) return true;
          return template.carbohydrates >= filters.macroRanges.carbohydrates.min && 
                 template.carbohydrates <= filters.macroRanges.carbohydrates.max;
        });
      }
    }
    
    // Diet types filter (multi) - supports legacy dietType and new dietTypes
    if (filters.dietTypes && filters.dietTypes.length > 0) {
      filtered = filtered.filter(template => {
        const legacy = template.dietType ? [template.dietType] : [];
        const multi = Array.isArray(template.dietTypes) ? template.dietTypes : [];
        const all = [...legacy, ...multi];
        if (all.length === 0) return false;
        return all.some((dt) => filters.dietTypes.includes(dt));
      });
    }

    // Template type filter
    if (filters.templateType && filters.templateType !== 'all') {
      filtered = filtered.filter(template => {
        if (filters.templateType === 'weekly') {
          return template.isWeekly === true;
        }
        if (filters.templateType === 'daily') {
          return template.isWeekly !== true;
        }
        return true;
      });
    }
    
    // Origin filter (custom vs default)
    if (filters.templateOrigin && filters.templateOrigin !== 'all') {
      filtered = filtered.filter(template => {
        if (filters.templateOrigin === 'custom') return !template.isDefault;
        if (filters.templateOrigin === 'default') return !!template.isDefault;
        return true;
      });
    }
    
    // Intolerances filter
    if (filters.intolerances && filters.intolerances.length > 0) {
      filtered = filtered.filter(template => {
        if (!template.intolerances || template.intolerances.length === 0) return true;
        return filters.intolerances.some((intolerance: string) => 
          template.intolerances?.includes(intolerance)
        );
      });
    }
    
    // Tags filter
    if (filters.tags && filters.tags.length > 0) {
      filtered = filtered.filter(template => {
        if (!template.tags || template.tags.length === 0) return false;
        return filters.tags.some((tag: string) => template.tags?.includes(tag));
      });
    }
    
    // Sorting
    if (filters.sortBy) {
      filtered.sort((a, b) => {
        let aValue: any;
        let bValue: any;
        
        if (filters.sortBy === 'name') {
          aValue = a.name.toLowerCase();
          bValue = b.name.toLowerCase();
        } else if (filters.sortBy === 'lastUpdated') {
          aValue = new Date(a.updatedAt);
          bValue = new Date(b.updatedAt);
        }
        
        if (filters.sortOrder === 'desc') {
          [aValue, bValue] = [bValue, aValue];
        }
        
        if (aValue < bValue) return -1;
        if (aValue > bValue) return 1;
        return 0;
      });
    }
    
    return filtered;
  }
}

// Export sample data for testing
export { SAMPLE_TEMPLATES };
